
export const getRowColor = (state) => {
  switch (state?.toString()) {
    case "0":
      return '#d0f0d0'; // En curso
    case "1":
      return '#d0d8f8'; // Baja
    case "2":
      return '#f8d0d0'; // Vencido
    default:
      return 'white';
  }
};
